import { createContext, useContext, useMemo } from 'react';
import { useFormsContext } from '@ally/forms';
import { getAccountId } from '@ally/transfer-account-utils';
import { getIsIraPaperForm, getIsIraWithdrawal, getTransferFrequency, getTransferType, } from '../utils';
import { TransferSpeedsContext } from './useTransferSpeeds';
import { RemoteStatus } from '../Remote';
export var TransferAccountsContext = createContext([]);
var useComputedValues = function () {
    var values = useFormsContext().values;
    var fromAccountId = values.fromAccount, toAccountId = values.toAccount, frequencyValue = values.frequency;
    var accounts = useContext(TransferAccountsContext);
    var transferSpeeds = useContext(TransferSpeedsContext).transferSpeeds;
    var disableForm = transferSpeeds.status === RemoteStatus.Failed;
    var fromAccount = useMemo(function () {
        return accounts.find(function (account) { return getAccountId(account) === fromAccountId; }) || null;
    }, [accounts, fromAccountId]);
    var toAccount = useMemo(function () {
        return accounts.find(function (account) { return getAccountId(account) === toAccountId; }) || null;
    }, [accounts, toAccountId]);
    var frequency = useMemo(function () { return getTransferFrequency(frequencyValue); }, [frequencyValue]);
    var transferType = useMemo(function () { return getTransferType(fromAccount, toAccount); }, [
        fromAccount,
        toAccount,
    ]);
    var isIraWithdrawal = useMemo(function () { return getIsIraWithdrawal(fromAccount, toAccount); }, [fromAccount, toAccount]);
    var isIraPaperForm = useMemo(function () { return getIsIraPaperForm(fromAccount); }, [
        fromAccount,
    ]);
    return {
        fromAccount: fromAccount,
        toAccount: toAccount,
        frequency: frequency,
        transferType: transferType,
        disableForm: disableForm,
        isIraWithdrawal: isIraWithdrawal,
        isIraPaperForm: isIraPaperForm,
    };
};
export default useComputedValues;
//# sourceMappingURL=useComputedValues.js.map